import React, { Fragment } from "react";

const HTTPMethod = ({ method }) => {
  return (
    <Fragment>
      <span className={`http-method http-method--${method.toLowerCase()} f6`}>
        {method}
      </span>
      <style jsx>
        {`
          .http-method {
            font-family: "Menlo", monspace;
          }
          .http-method--post {
            color: green;
          }
          .http-method--get {
            color: blue;
          }
          .http-method--put {
            color: green;
          }
          .http-method--delete {
            color: red;
          }
        `}
      </style>
    </Fragment>
  );
};

export default HTTPMethod;
